module.exports = __webpack_public_path__ + "static/media/rotate-color.a708e90b.svg";